import { render, staticRenderFns } from "./ProfileSidebarTitle.vue?vue&type=template&id=6763dfde&scoped=true"
import script from "./ProfileSidebarTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSidebarTitle.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSidebarTitle.vue?vue&type=style&index=0&id=6763dfde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6763dfde",
  null
  
)

export default component.exports